import { Box } from '@mui/material'
import Container from 'components/Container'
import {
  ButtonSkeleton,
  LogoSkeleton,
  DescriptionSkeleton,
  ModelSkeleton,
  SkeletonContainer,
  StatSkeleton,
  StatSkeletonContainer,
} from './styled'

const LoadingState = () => {
  return (
    <Container sx={{ minHeight: 'calc(100vh - 80px)' }}>
      <SkeletonContainer>
        <Box component="div">
          <LogoSkeleton variant="rectangular" />
          <DescriptionSkeleton variant="rectangular" />
          <StatSkeletonContainer>
            {[...Array(3)].map((_, index) => (
              <StatSkeleton key={index} />
            ))}
          </StatSkeletonContainer>
          <Box component="div" display="flex" gap={2}>
            <ButtonSkeleton />
            <ButtonSkeleton />
          </Box>
        </Box>
        <ModelSkeleton variant="rectangular" />
      </SkeletonContainer>
    </Container>
  )
}

export default LoadingState
